import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PLATFORMS } from "@/lib/format";

export const CustomerFilters = ({ filters, onFilterChange, categories, isAdmin, onClear, onSaveSegment }) => (
  <Card className="shadow-sm fade-in" data-testid="filters-panel">
    <CardContent className="p-6 grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="space-y-1.5">
        <Label>Spent at least ($)</Label>
        <Input type="number" data-testid="filter-min-spend" value={filters.min_spend} onChange={(e) => onFilterChange("min_spend", e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <Label>Spent at most ($)</Label>
        <Input type="number" value={filters.max_spend} onChange={(e) => onFilterChange("max_spend", e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <Label>Bought from</Label>
        <Select value={filters.platform || "all"} onValueChange={(v) => onFilterChange("platform", v === "all" ? "" : v)}>
          <SelectTrigger data-testid="filter-platform"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Anywhere</SelectItem>
            {PLATFORMS.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label>Bought category</Label>
        <Select value={filters.category || "all"} onValueChange={(v) => onFilterChange("category", v === "all" ? "" : v)}>
          <SelectTrigger data-testid="filter-category"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Any category</SelectItem>
            {categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label>Tag</Label>
        <Input placeholder="e.g. Partner" value={filters.tag} onChange={(e) => onFilterChange("tag", e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <Label>State</Label>
        <Input placeholder="e.g. TX" data-testid="filter-state" value={filters.state} onChange={(e) => onFilterChange("state", e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <Label>Last purchase after</Label>
        <Input type="date" value={filters.purchased_after} onChange={(e) => onFilterChange("purchased_after", e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <Label>Last purchase before</Label>
        <Input type="date" value={filters.purchased_before} onChange={(e) => onFilterChange("purchased_before", e.target.value)} />
      </div>
      <div className="flex items-end gap-2">
        <Button variant="ghost" onClick={onClear} data-testid="clear-filters-btn">
          Clear filters
        </Button>
        {isAdmin && (
          <Button variant="secondary" onClick={onSaveSegment} data-testid="save-as-segment-btn">
            Save as a group
          </Button>
        )}
      </div>
    </CardContent>
  </Card>
);
